import Service, { type Registry as Services, service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type { DestinationSubscription } from 'frontend-utils/models';

export default class DestinationService extends Service {
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  @tracked destinationSubscription?: DestinationSubscription;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get timezone() {
    return this.destinationSubscription?.timezone;
  }

  resetDestinationSubscription(): void {
    this.destinationSubscription = undefined;
  }

  setDestinationSubscription(destination: DestinationSubscription): void {
    this.destinationSubscription = destination;
    this.hotelAndMarketService.hotel = null;
    this.hotelAndMarketService.market = null;
  }
}

declare module '@ember/service' {
  interface Registry {
    destination: DestinationService;
  }
}
